var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"search-option-wrapper"},[_c('span',[_vm._v(_vm._s(_vm.label))]),_c('div',{staticClass:"search-option-wrapper__normal"},[_c('el-checkbox',{attrs:{"value":_vm.value},on:{"change":_vm.onchange}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }